import React, { useState, useEffect } from "react";
import { Row, Col, Button, Breadcrumb, BreadcrumbItem } from "shards-react";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import styled from "styled-components";
import useCurrentUser from "shared/hook/useCurrentUser";

const axios = require("axios").default;

const StyledBreadcrumb = styled(Breadcrumb)`
  .breadcrumb {
    padding: 0 !important;
  }
`;
const QuiryformDetail = (props) => {
  const { match } = props;
  const { token } = useToken();
  const { curruntUser } = useCurrentUser();
  const [dataAgencyList, setDataAgencyList] = useState(null);
  const [questionnaireId, setQuestionnaireId] = useState(match.params.id);

  const [agencyId, setAgencyId] = useState("");
  const [questionnaireEmail, setQuestionnaireEmail] = useState("");
  const [questionnaireFname, setQuestionnaireFname] = useState("");
  const [questionnaireHeadTopic, setQuestionnaireHeadTopic] = useState("");
  const [questionnaireLname, setQuestionnaireLname] = useState("");
  const [questionnairePhone, setQuestionnairePhone] = useState("");
  const [questionnaireTopic, setQuestionnaireTopic] = useState("");
  const [questionnaireStatus, setQuestionnaireStatus] = useState("");
  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          questionnaireId: questionnaireId,
        },
        show: 1,
        page: 1,
        orderBy: "questionnaireId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/questionnairelist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          if (response.data.data.length > 0) {
            const item = response.data.data[0];
            setQuestionnaireEmail(item.questionnaireEmail);
            setQuestionnaireFname(item.questionnaireFname);
            setQuestionnaireHeadTopic(item.questionnaireHeadTopic);
            setQuestionnaireLname(item.questionnaireLname);
            setQuestionnairePhone(item.questionnairePhone);
            setQuestionnaireTopic(item.questionnaireTopic);
            setQuestionnaireStatus(item.questionnaireStatus);
            setAgencyId(item.agencyId);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [questionnaireId]);
  useEffect(() => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      params: {
        agencyTypeId: "",
      },
      show: 100,
      page: 1,
      orderBy: "agencyName",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/agencylist`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setDataAgencyList(response.data);
      })
      .catch(function(error) {
        console.log("setting/agencylist", error);
      });
  }, []);
  const getAgencyName = (agencyId) => {
    const list =
      dataAgencyList != null &&
      dataAgencyList.data.length > 0 &&
      dataAgencyList.data.filter((item) => item.agencyId === agencyId);

    return list.length > 0 ? list[0].agencyName : "";
  };
  let userMail = "";
  if (curruntUser) {
    userMail = curruntUser.user.email;
  }
  const upDateStatus = (id, status) => {
    if (status !== 3) {
      var data = JSON.stringify({
        params: {
          questionnaireId: id,
        },
        update: {
          questionnaireStatus: 3,
        },
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/updatequestionnaire`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function(response) {
          window.location = `mailto:${questionnaireEmail}?subject=${questionnaireHeadTopic}&body=${questionnaireTopic}`;
        })
        .catch(function(error) {
          console.log("setting/agencylist", error);
        });
    }else{

      window.location = `mailto:${questionnaireEmail}?subject=${questionnaireHeadTopic}&body=${questionnaireTopic}`;
    }
  };

  return (
    <>
      <Row>
        <Col>
          <StyledBreadcrumb>
            <BreadcrumbItem>
              <a
                href="/administrator/inquiryform"
                style={{ color: "#8D8D8D" }}
              >{`< กลับ`}</a>
            </BreadcrumbItem>
          </StyledBreadcrumb>
        </Col>
      </Row>
      <Row>
        <Col md="3">
          <h6 className="bold">ชื่อ-นามสกุล</h6>
          <div>
            {questionnaireFname} {questionnaireLname}
          </div>
        </Col>
        <Col md="3">
          <h6 className="bold">อีเมล</h6>
          <div>{questionnaireEmail}</div>
        </Col>
        <Col md="3">
          <h6 className="bold">หน่วยงาน/บริษัท</h6>
          <div>{getAgencyName(agencyId)}</div>
        </Col>
        <Col md="3">
          <h6 className="bold">เบอร์ติดต่อ</h6>
          <div>{questionnairePhone}</div>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md="8" style={{ marginBottom: "30px" }}>
          <h6 className="bold">หัวข้อสอบถาม</h6>
          <div>{questionnaireHeadTopic}</div>
        </Col>
        <Col md="4">
          <a
            className="btn btn-outline-primary pull-right"
            onClick={() =>
              upDateStatus(
                questionnaireId,
                questionnaireStatus
              )
            }
            style={{ cursor: "pointer" ,  width: "150px"}}
          >
            ตอบกลับอีเมล
          </a>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <h6 className="bold">รายละเอียด</h6>
          <div>{questionnaireTopic}</div>
        </Col>
      </Row>
    </>
  );
};

export default QuiryformDetail;
